import { useSearchParams } from '@solidjs/router';
import { createEffect, type Component, createSignal } from 'solid-js';
import { ory } from '../shared';

const Error: Component = () => {
  const [queryParams] = useSearchParams();
  const [errors, setErrors] = createSignal('');

  createEffect(() => {
    ory
      .getFlowError({ id: queryParams.id || '' })
      .then(res => res.data)
      .then(data => {
        setErrors(JSON.stringify(data, null, 2));
      });
  });

  return (
    <>
      <p>Error</p>
      <pre>{errors()}</pre>
    </>
  );
};

export default Error;
